module.exports = __webpack_public_path__ + "img/ui.e3ff0540.png";